<template>
  <section class="cta" aria-labelledby="cta-title">
    <div class="container inner">
      <div class="text">
        <h2 id="cta-title">{{ content.title }}</h2>
        <p>{{ content.text }}</p>
      </div>
      <div class="btn-row">
        <a v-if="content.primary.external" class="btn btn--ink" :href="content.primary.to" rel="noopener">{{ content.primary.label }}</a>
        <router-link v-else class="btn btn--ink" :to="content.primary.to">{{ content.primary.label }}</router-link>
        <router-link class="btn btn--ghost" :to="content.secondary.to">{{ content.secondary.label }}</router-link>
      </div>
    </div>
  </section>
</template>

<script>
  import site from "@/content/site";

  const VARIANTS = {
    // Pages du logiciel et du blog
    product: {
      title: 'Essayez le logiciel de devis et factures',
      text: 'Un seul outil pour vos prospects, devis, factures Factur-X et encaissements. Une question avant de vous lancer ? Écrivez-nous.',
      primary: {label: 'Accéder au gestionnaire', to: site.productUrl, external: true},
      secondary: {label: 'Poser une question', to: '/contact'},
    },
    // Pages des services (site vitrine, logiciel sur mesure, à propos)
    services: {
      title: 'Parlons de votre projet',
      text: 'Un site, une application ou un logiciel à reprendre : décrivez votre projet, vous recevez un devis personnalisé.',
      primary: {label: 'Demander un devis', to: '/contact', external: false},
      secondary: {label: 'Découvrir le logiciel de facturation', to: '/gestionnaire-citron'},
    },
  };

  export default {
    name: 'CallToActionComponent',
    props: {
      variant: {type: String, default: 'product'},
    },
    computed: {
      content() {
        return VARIANTS[this.variant] || VARIANTS.product;
      },
    },
  }
</script>

<style lang="stylus" scoped>
@import '~/src/common/style/constants.styl';

// Bandeau citron : il sépare nettement le contenu du pied de page bleu nuit
.cta
  padding-top clamp(40px, 6vw, 72px)
  padding-bottom clamp(40px, 6vw, 72px)
  background LEMON
  border-top 2px solid INK
  color INK

.inner
  display flex
  flex-direction column
  gap 24px

h2
  margin 0 0 10px
  font-size clamp(1.7rem, 3.6vw, 2.4rem)

p
  margin 0
  max-width 54ch
  color INK

@media (min-width: DESKTOP_SIZE)
  .inner
    flex-direction row
    align-items center
    justify-content space-between
    gap 48px
  .btn-row
    flex none
</style>
